export class ValueObject {
    equals(other) {
        if (other === null || other === undefined)
            return false;
        return JSON.stringify(this) === JSON.stringify(other);
    }
}
